import CustomTable from './CustomTable.container';

export default CustomTable;
